import { render, staticRenderFns } from "./DeviceHistory.vue?vue&type=template&id=c28c1dfe"
import script from "./DeviceHistory.vue?vue&type=script&lang=ts"
export * from "./DeviceHistory.vue?vue&type=script&lang=ts"
import style0 from "./DeviceHistory.vue?vue&type=style&index=0&id=c28c1dfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports